import { useParams } from "react-router";
import { useRootPath } from "../infrastructure/translation/useRootPath";

export function clientPaths(rootPath: string, orgnr: string) {
  const organization = `${rootPath}/organization/${orgnr}`;

  return {
    organization,
    newClient: `${organization}/clients/new`,
    client: (clientId: string) => `${organization}/clients/${clientId}`,
    editClient: (clientId: string) =>
      `${organization}/clients/${clientId}/edit`,
  };
}

export const useClientPaths = () => {
  const { orgnr } = useParams<{ orgnr: string }>();
  const rootPath = useRootPath();

  return clientPaths(rootPath, orgnr!);
};
